import { useIntl } from "react-intl";
import appleTouchIcon from "../../assets/bread/en-us/favicons/apple-touch-icon.png";
import faviconIco from "../../assets/bread/en-us/favicons/favicon.ico";
import iconSvg from "../../assets/bread/en-us/favicons/icon.svg";
import { useLocalePublicPath } from "../../utils/usePublicPath";

export const PageHead: React.FC = () => {
	const manifestVersion = "4";
	const publicPath = useLocalePublicPath();
	const intl = useIntl();

	return (
		<>
			<meta
				name="description"
				content={intl.formatMessage({
					defaultMessage:
						"You can sign in to make a payment on your Bread Pay loan or your Bread Loan. Easily manage your loan from our Member Portal.",
				})}
			/>
			<link rel="icon" href={faviconIco} type="image/x-icon" />
			<link rel="icon" href={iconSvg} type="image/svg+xml" />
			<meta
				name="apple-mobile-web-app-title"
				content={intl.formatMessage({ defaultMessage: "Member Portal" })}
			/>
			<link rel="apple-touch-icon" href={appleTouchIcon} type="image/png" />
			<link
				rel="manifest"
				href={`${publicPath}/favicons/site.webmanifest?v=${manifestVersion}`}
				type="application/manifest+json"
			/>
			<meta name="mobile-web-app-capable" content="yes" />
			<meta name="theme-color" content="#fff" />
		</>
	);
};
